import type { DefaultValues, SubmitHandler } from 'react-hook-form';
import { useForm } from 'react-hook-form';

import type { IContentBlockFormBodyProps } from '~/components/molecules/ContentBlock';
import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useFormAutoFocus } from '~/hooks/useFormAutoFocus';
import { LiveStreamFormMainSection } from './LiveStreamFormMainSection';

export type ILiveStreamFormValues = {
  name?: string;
  startDateTime?: string;
};

export type ILiveStreamFormProps = IContainerProps &
  Omit<
    IContentBlockFormBodyProps<ILiveStreamFormValues>,
    'form' | 'children' | 'onSubmit' | 'submitting'
  > & {
    mode: IFormMode;
    defaultValues?: DefaultValues<ILiveStreamFormValues>;
    onSubmit?: SubmitHandler<ILiveStreamFormValues>;
  };

export const LiveStreamForm: React.FC<ILiveStreamFormProps> = (props) => {
  const { sx, mode, defaultValues, onSubmit, ...other } = props;

  const form = useForm<ILiveStreamFormValues>({
    defaultValues,
  });
  useFormAutoFocus({ form, name: 'name' });

  return (
    <ContentBlock.FormBody sx={sx} form={form} onSubmit={onSubmit} {...other}>
      <LiveStreamFormMainSection form={form} mode={mode} />
    </ContentBlock.FormBody>
  );
};
